import{gql as e}from"@apollo/client";import{CONTENT_PAGE_CONTEXT_GRAPHQL as n}from"../../contexts/ContentPageContext/ContentPageContext.graphql.js";const t=e`
  query getContentGroup(
    $contentGroupId: Int!
    $contentPageId: Int
    $topLevelOnly: Boolean
    $userFlowStepTrackId: Int!
    $withAnswers: Boolean!
  ) {
    contentGroup {
      getContentGroup(contentGroupId: $contentGroupId) {
        contentPages(status: [PUBLISHED, UNPUBLISHED], topLevelOnly: $topLevelOnly) {
          ...contentPage
        }
        description
        iconAsset {
          contentType
          s3Key
        }
        regions {
          iconSize
          iconType
          id
          x
          y
          name
        }
        title
        url
      }
    }
  }

  ${n.fragments.asset}
  ${n.fragments.bubbleText}
  ${n.fragments.contentEvent}
  ${n.fragments.contentEventOnPage}
  ${n.fragments.contentPage}
  ${n.fragments.contentSnippet.app}
  ${n.fragments.contentSnippet.audio}
  ${n.fragments.contentSnippet.avatar}
  ${n.fragments.contentSnippet.button}
  ${n.fragments.contentSnippet.cluster}
  ${n.fragments.contentSnippet.code}
  ${n.fragments.contentSnippet.document}
  ${n.fragments.contentSnippet.embed}
  ${n.fragments.contentSnippet.form}
  ${n.fragments.contentSnippet.image}
  ${n.fragments.contentSnippet.imageMap}
  ${n.fragments.contentSnippet.map}
  ${n.fragments.contentSnippet.question}
  ${n.fragments.contentSnippet.quote}
  ${n.fragments.contentSnippet.slider}
  ${n.fragments.contentSnippet.spacer}
  ${n.fragments.contentSnippet.summary}
  ${n.fragments.contentSnippet.summaryResult}
  ${n.fragments.contentSnippet.text}
  ${n.fragments.contentSnippet.video}
  ${n.fragments.cssStyle}
  ${n.fragments.margin}
  ${n.fragments.questionAnswer.calendar}
  ${n.fragments.questionAnswer.checkbox}
  ${n.fragments.questionAnswer.checkboxResponseCheckbox}
  ${n.fragments.questionAnswer.decimal}
  ${n.fragments.questionAnswer.dropdownList}
  ${n.fragments.questionAnswer.interface}
  ${n.fragments.questionAnswer.rating}
  ${n.fragments.questionAnswer.match}
  ${n.fragments.questionAnswer.multiLineText}
  ${n.fragments.questionAnswer.multiResponseText}
  ${n.fragments.questionAnswer.multiResponseTextItem}
  ${n.fragments.questionAnswer.number}
  ${n.fragments.questionAnswer.radio}
  ${n.fragments.questionAnswer.singleLineText}
  ${n.fragments.questionAnswer.slider}
  ${n.fragments.questionConfigurationMessage}
  ${n.fragments.responseSet}
  ${n.fragments.sectionGroupTab}
  ${n.fragments.summaryFeedbackConfigurationRange}
  ${n.fragments.summaryFeedbackConfigurationRadio}
  ${n.fragments.summaryFeedbackConfigurationCheckbox}
  ${n.fragments.summaryFeedbackConfigurationMultiResponse}
  ${n.fragments.summaryFeedbackConfigurationRankAndNote}
  ${n.fragments.tag}
`;export{t as GET_CONTENT_GROUP_QUERY};
//# sourceMappingURL=useGetContentGroup.graphql.js.map
